import { Component, OnInit, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AudioPlayerService } from '../../services/audio-player.service';
import { AuthService } from '../../services/auth.service';

type SettingType = 'hoofddeksel' | 'gezicht' | 'attribuut' | 'achtergrond';

interface ISettingOption {
  value: number;
  name: string;
}
interface ISettingType {
  name: SettingType;
  values: ISettingOption[];
  default: number;
}

interface ISettingSelection {
    name: SettingType
    value: number;
};


@Component({
  selector: 'app-create-avatar',
  templateUrl: './create-avatar.component.html',
  styleUrls: ['./create-avatar.component.less']
})
export class CreateAvatarComponent implements OnInit, AfterViewInit {
  @HostListener('window:resize', ['$event']) onResize(event: Event) {
    this.updateAvatar();
  }
  public settings: ISettingType[] = [
    {
      name: 'hoofddeksel',
      values: [
        {value: 1, name: 'geen'},
        {value: 2, name: 'bloem'},
        {value: 3, name: 'piratenhoed'},
        {value: 4, name: 'petje'},
        {value: 5, name: 'hoed'}
      ],
      default: 0
    },
    {
      name: 'gezicht',
      values: [
        {value: 1, name: '0'},
        {value: 2, name: '1'},
        {value: 3, name: '2'},
        {value: 4, name: '3'},
        {value: 5, name: '4'}
      ],
      default: 0
    },
    {
      name: 'attribuut',
      values: [
        {value: 1, name: 'geen'},
        {value: 2, name: 'ketting'},
        {value: 3, name: 'bal'},
        {value: 4, name: 'boek'},
        {value: 5, name: 'hond'}
      ],
      default: 0
    },
    {
      name: 'achtergrond',
      values: [
        {value: 1, name: 'geen'},
        {value: 2, name: 'geel'},
        {value: 3, name: 'rood'},
        {value: 4, name: 'paars'},
        {value: 5, name: 'blauw'}
      ],
      default: 0
    }
  ]

  sending = false;
  constructor(private elRef: ElementRef, private router: Router, public audio: AudioPlayerService, public auth: AuthService) {
    const current = this.auth.getAvatar()?.split('.');

    this.activeSetting  = this.settings.map((settingType, index) => {
      return {
        name: settingType.name,
        value: current ?
          (current[index] ? +current[index] -1 : settingType.default)
            : settingType.default
      }
    })
    this.activeImageUrl = '/img/avatar2/Avatar_' + this.getSettingString() + '.svg';
    this.username = this.auth.getUsername().toUpperCase();
  }

  ngAfterViewInit(): void {
    this.updateAvatar();
  }
  public activeSetting: ISettingSelection[] = [];
  public activeImageUrl: string = '/img/avatar2/avatars/Avatar_test.png';
  public username = '';
  // avatarLoaded() {
  //   console.log('svg available');
  //   this.updateAvatar();
  //   this.audio.play('createAvatar_info');
  //   const userNameEl = this.elRef.nativeElement.querySelector('avatarUsername');
  //   if (userNameEl) {
  //     userNameEl.innerHTML = '-* ' + this.auth.getUsername().toUpperCase() + ' *-';
  //   }
  //   this.updateAvatar();
  // }

  close() {
    this.sending = true;
    // store avatar
    this.auth.storeAvatar(this.getSettingString()).subscribe(x => {
      // If successfull redirect
      this.router.navigate(['dashboard']);
    }, error => {
      alert('an error occured while updating the avatar. ')
      console.error('Couldn\'t store avatar');
      this.sending = false;
    });;

    // this.auth.storeAvatar(
    //   this.activeSetting.skinTone +
    //   '.' +
    //   this.activeSetting.hairType + '.' +
    //   this.activeSetting.shirtColor + '.' +
    //   this.activeSetting.accessoire).subscribe(x => {
    //     // If successfull redirect
    //     this.router.navigate(['dashboard']);
    //   }, error => {
    //     console.log('Couldn\'t store avatar');
    //   });
  }

  private getSettingString() {
    return this.settings.map(settingConfig => {
      const activeValue = this.activeSetting.find(as=>as.name === settingConfig.name)?.value || 0;

      const value = settingConfig.values[activeValue].value;
      return value;
    }).join('.')
  }

  updateAvatar() {

    this.activeImageUrl = '/img/avatar2/Avatar_' + this.getSettingString() + '.svg';
    this.settings.forEach(settingType => {
      const selectorDiv = this.elRef.nativeElement.querySelector('#settingSelector' + settingType.name) as HTMLDivElement;
      const width = selectorDiv.querySelectorAll('.item')[1].scrollWidth;
      const settingTypeElement = selectorDiv.querySelector('.list-box');
      const currentValue = this.activeSetting.find(as => as.name === settingType.name)?.value || 0;

      if (settingTypeElement) {

        settingTypeElement.scrollLeft = width * (currentValue);
      } else {
        console.error('setting elemenet not found', settingType);
      }
    });
  }

  next(type: ISettingType) {
    let activeSetting = this.activeSetting.find(as => as.name === type.name);
    if (!activeSetting) {
      activeSetting = {name: type.name, value: type.default}
      this.activeSetting.push(activeSetting);
    }

    activeSetting.value++;
    if (activeSetting.value >= type.values.length) {
      activeSetting.value = 0;
    }

    this.updateAvatar();
  }
  prev(type: ISettingType) {
    let activeSetting = this.activeSetting.find(as => as.name === type.name);
    if (!activeSetting) {
      activeSetting = {name: type.name, value: type.default}
      this.activeSetting.push(activeSetting);
    }
    activeSetting.value--;
    if (activeSetting.value < 0) {
      activeSetting.value = type.values.length -1;
    }

    this.updateAvatar();
  }

  ngOnInit() {
  }
  btnContinueClicked() {
    // console.log('cliked');
    this.close();
    this.audio.playSoundClick();
  }
}
